import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf } from '@angular/common';

import { pageTransitions } from '../../../../shared/animations/page-transitions';
import { Guarantee } from '../../../models/guarantee';
import { LocationService } from '../../../../shared/services/location.service';
import { User } from '../../../../shared/models/user';
import { UserService } from '../../../../shared/services/user.service';
import { GuaranteeRequestService } from '../../../services/guarantee-request.service';
import { PageHeaderComponent } from '../../../../shared/components/page-header/page-header.component';

@Component({
	selector: 'copo-guarantee-type-selector',
	templateUrl: './guarantee-type-selector.component.html',
	styleUrl: './guarantee-type-selector.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,

	imports: [PageHeaderComponent, NgIf, TranslateModule, MatButtonModule, MatIconModule]
})

export class GuaranteeTypeSelectorComponent {
	guarantee: Guarantee;

	user: User;
	constructor(
		private readonly locationService: LocationService,
		private readonly userService: UserService,
		private readonly guaranteeService: GuaranteeRequestService,
		private readonly router: Router,
	) {
		this.guaranteeService.guarantee = new Guarantee();
		this.guarantee = this.guaranteeService.guarantee;
		this.user = this.userService.user;
	}

	solarApplication() {
		this.guarantee.applicationType = 'Magnelis-Solar';
		this.goNext();
	}

	buildingApplication() {
		this.guarantee.applicationType = 'Magnelis-Building';
		this.goNext();
	}

	otherApplication() {
		this.guarantee.applicationType = 'Magnelis-Other application';
		this.goNext();
	}

	organicCoatingApplication() {
		this.guarantee.applicationType = 'Organic Coating';
		this.guarantee.recordType = 'Organic Coating';
		this.goNext();
	}

	goBack() {
		this.locationService.go(-1);
	}

	goNext() {
		this.router.navigate(['/guarantee-requests/new/project-characteristics'], { replaceUrl: true })
			.catch(() => false);
	}

	hasSolarAccess() {
		return this.user.hasServiceParameterEqualsTo('PGNTE', 'magnelissolar', 'Standard')
			|| this.user.hasServiceParameterEqualsTo('PGNTE', 'magnelissolar', 'Spain');
	}

	hasBuildingAccess() {
		return this.user.hasServiceParameterEqualsTo('PGNTE', 'magnelisbuilding', 'Standard');
	}

	hasOthersAccess() {
		return this.user.hasServiceParameterEqualsTo('PGNTE', 'magnelisothers', 'Standard');
	}

	hasOrganicCoatingAccess() {
		return this.user.hasServiceParameterEqualsTo('PGNTE', 'organiccoating', 'Standard');
	}

	noOfSelectables() {
		let parameterList = this.user.getService('PGNTE')?.parameters;
		if (parameterList) {
			parameterList = parameterList.filter(param => param.value !== 'None');
			if (parameterList.length === 1) {
				switch (parameterList[0].name) {
				case 'magnelissolar':
					this.solarApplication();
					break;
				case 'magnelisbuilding':
					this.buildingApplication();
					break;
				case 'magnelisothers':
					this.otherApplication();
					break;
				case 'organiccoating':
					this.organicCoatingApplication();
					break;
				}
			}
			return parameterList.length;
		}
		return 0;
	}
}
